import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { SelectionHoverNodeCommand, SelectionSelectNodeCommand } from '@beefco/sdk-tools/commands';
export var SelectionState = /*#__PURE__*/function () {
  function SelectionState(bus) {
    _classCallCheck(this, SelectionState);
    this.bus = bus;
    _defineProperty(this, "selectionNodeId", null);
    _defineProperty(this, "hoverNodeId", null);
    _defineProperty(this, "selectionUniqueId", null);
    _defineProperty(this, "hoverUniqueId", null);
    _defineProperty(this, "changeTimer", void 0);
  }
  _createClass(SelectionState, [{
    key: "handleSelection",
    value: function handleSelection(_ref) {
      var nodeId = _ref.nodeId,
        uniqueId = _ref.uniqueId;
      this.selectionNodeId = nodeId;
      this.selectionUniqueId = uniqueId;
      this.bus.execute(new SelectionSelectNodeCommand({
        nodeId: nodeId,
        uniqueId: uniqueId
      }));
    }
  }, {
    key: "setHover",
    value: function setHover(_ref2) {
      var nodeId = _ref2.nodeId,
        uniqueId = _ref2.uniqueId;
      this.hoverNodeId = nodeId;
      this.hoverUniqueId = uniqueId;
      this.bus.execute(new SelectionHoverNodeCommand({
        nodeId: nodeId,
        uniqueId: uniqueId
      }));
    }
  }, {
    key: "handleHover",
    value: function handleHover() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$nodeId = _ref3.nodeId,
        nodeId = _ref3$nodeId === void 0 ? null : _ref3$nodeId,
        _ref3$uniqueId = _ref3.uniqueId,
        uniqueId = _ref3$uniqueId === void 0 ? null : _ref3$uniqueId;
      window.clearTimeout(this.changeTimer);
      this.setHover({
        nodeId: nodeId,
        uniqueId: uniqueId
      });
    }
  }, {
    key: "handleLeave",
    value: function handleLeave() {
      var _this = this;
      window.clearTimeout(this.changeTimer);
      this.changeTimer = window.setTimeout(function () {
        return _this.handleHover();
      }, 50);
    }
  }]);
  return SelectionState;
}();